import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import getProductType from './ProductType';

function GuestGuard({ children }) {
  const account = useSelector(state => state.account);

  const productType = getProductType();

  if (account.user) {
    return (
      <Redirect
        to={
          productType === 'Precisa'
            ? '/precisa/home'
            : `/${productType.toLowerCase()}/home`
        }
      />
    );
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.any
};

export default GuestGuard;
